import { Component, OnInit, Inject, Input } from '@angular/core';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';



export interface DialogData {
	ParamsName : string; 
  typechoice: string[];
	formule: any;
}

export interface Fruit {
  name: string;
}


@Component({
  selector: 'app-typedefdialog',
  templateUrl: './typedefdialog.component.html',
  styleUrls: ['./typedefdialog.component.css']
})
export class TypedefdialogComponent implements OnInit {

  addOnBlur = false;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  fruits: Fruit[] = [];

  paramName = '' ;
  typeNames   = [] ;

  Tabval = "" ;

  resultArray = [] ;
  checkStatus = [] ;
  checkboxEditDeactivate = [] ;

  subTabLength =3 ;

  choicebi = "" ;

  choosenType=""

  selected = "" ;

  isDouble : any ;

  incomingFormule: any ;

  summonedFormule = "primform" ;
  parmsToFormulate = "" ;

  determinantIntervalles = [] ;
  showMeIntervalles = [] ;

  saveBtnState = "done_all" ;

  headClass = "card-header card-header-tabs card-header-primary" ;

  constructor(public dialogRef: MatDialogRef<TypedefdialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  	this.paramName = data.ParamsName ;
    this.typeNames = data.typechoice ;
    this.incomingFormule = data.formule ;
  	this.parmsToFormulate = JSON.stringify(data.typechoice) ;

    /*
    if(this.typeNames[0]=="***")
      this.summonedFormule = "paramform" ;
    else
      this.summonedFormule = "primform" ;
    */
  	console.log(this.typeNames) ;
  }

  ngOnInit(): void {
  	var onChunkArray = [] ;
  	var index = 0 ;
  	this.resultArray = this.typeNames.reduce((indexDead, item ) => { 
  		const chunkIndex = Math.floor(index/this.subTabLength)
  		if(!onChunkArray[chunkIndex]) {
  			onChunkArray[chunkIndex] = [] // start a new chunk
  		}
  		onChunkArray[chunkIndex].push(item) ;
  		index++ ;
  		return onChunkArray ;
  	}, []) ;

  	for (var i = 0; i< this.typeNames.length; i++) {
  		this.checkStatus.push(false) ;
  		this.checkboxEditDeactivate.push(false) ;
  	}
  }

  onPrimeChoose(event, i, j) {
  	if (event.target.checked){
  		this.checkStatus[j+2*i]=true ;
  	}
  	else{
  	  	console.log("UNCHECKED "+event.target.value) ;
    		this.checkStatus[j+2*i]=false ;	  	
  	}
  }

  soppiMbirrMi(domaine){

	  this.Tabval = (this.Tabval==this.paramName)? "-":this.paramName ;
  }

  saveTypeConfig(){
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.fruits.push({name: value.trim()});
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  getSens(){
    if (this.selected=="entre")
      return "Entre" ;
    if (this.selected=="infeg")
      return "Inferieur ou Egal à" ;
    if (this.selected=="supeg")
      return "Superieur ou Egal à" ;
    if (this.selected=="infstrict")
      return "Inferieur Strictement à" ;
    if (this.selected=="supstrict")
      return "Superieur Strictement à" ;
  }

  selectDeterminant(event){
    this.selected = event.value ;
    if(this.selected=="entre")
      this.showMeIntervalles.push(true) ;
    else
      this.showMeIntervalles.push(false) ;

    this.determinantIntervalles.push(this.getSens()) ;
  }

  changeTypeChoice(event){
    this.choosenType = event.value ;
    if(this.choosenType=="Choix multiple")
      this.choicebi='choixmultiple' ;
    if(this.choosenType=="Intervalle")
      this.choicebi='intervalle' ;
    if(this.choosenType=="Calculée")
      this.choicebi='calculee' ;
  }

  weShallTakeThis(formuledType){
    console.log("The true Thing is here") ;
    console.log(formuledType);
    this.dialogRef.close(formuledType);
  }

}
